
angular.module('dyb.util.efls', []);
